import { formatDateHeader } from "../../utils/time";

interface Props {
  utcIso: string;
  directionsUrl?: string | null;
}

export function DayHeader({ utcIso, directionsUrl }: Props) {
  return (
    <div className="sticky top-14 z-[5] bg-slate-50/95 backdrop-blur py-2 -mx-4 px-4 flex items-center justify-between gap-2">
      <span className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
        {formatDateHeader(utcIso, "ko-KR")}
      </span>
      {directionsUrl && (
        <a
          href={directionsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-xs font-medium text-rose-600 hover:text-rose-700"
          aria-label="이 날의 동선을 Google Maps에서 보기"
        >
          <svg
            viewBox="0 0 24 24"
            width="14"
            height="14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M12 2 4 6v12l8 4 8-4V6z" />
            <path d="M12 22V10" />
            <path d="m4 6 8 4 8-4" />
          </svg>
          <span>동선 보기</span>
        </a>
      )}
    </div>
  );
}
